var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Axios from 'axios';
import defaultConfig from './default';
import { requestSuccessFunc, requestFailFunc, responseSuccessFunc, responseFailFunc } from './interceptor';
import apis from '../api/index';
var BASE_URL = window.location.origin + defaultConfig.BASE_URL;
var baseURL = '';
if (defaultConfig.MOCK && process.env.NODE_ENV === 'development') {
    baseURL = defaultConfig.BASE_URL_MOCK;
}
else {
    baseURL = BASE_URL;
}
var axios = Axios.create({
    baseURL: baseURL,
    responseType: 'json',
    withCredentials: true,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    },
    timeout: defaultConfig.TIMEOUT
});
axios.interceptors.request.use(requestSuccessFunc, requestFailFunc);
axios.interceptors.response.use(responseSuccessFunc, responseFailFunc);
var apisConfig = {};
var apisMap = {};
Object.keys(apis).forEach(function (apiType) {
    Object.keys(apis[apiType]).forEach(function (apiItem) {
        apisConfig[apiType + "/" + apiItem] = apis[apiType][apiItem];
    });
});
Object.keys(apisConfig).forEach(function (key) {
    var configOri = apisConfig[key];
    function request(params, extend) {
        var config = __assign({}, configOri);
        params = Object.assign({}, params);
        config.method = config.method.toLowerCase() || 'get';
        if (config.method === 'get') {
            config.params = params;
        }
        if (config.method === 'post') {
            config.data = params;
        }
        if (config.disable_mock) {
            config.url = BASE_URL + config.url;
        }
        if (extend && extend.query) {
            config.params = __assign(__assign({}, config.params), extend.query);
        }
        if (extend && extend.headers) {
            config.headers = __assign(__assign({}, config.headers), extend.headers);
        }
        console.log(config);
        return axios.request(config);
    }
    apisMap[key] = request;
});
export default apisMap;



//////////////////
// WEBPACK FOOTER
// ./src/request/index.ts
// module id = null
// module chunks = 